import {BulkEditChangeRecord} from './bulk-edit-change-record';
import {TemplateComponentContent} from './template-component-content';

export class BulkEditChangeRecordResult {

  constructor(public requestIndex: number,
              public responseIndex: number,
              public bulkEditRecord: BulkEditChangeRecord,
              public responseValue: TemplateComponentContent | Error) {}

}
